import * as THREE from 'three';
import { makePickupMaterial } from '../materials/pickupMaterial';

const _m = new THREE.Matrix4();
const _p = new THREE.Vector3();
const _q = new THREE.Quaternion();
const _s = new THREE.Vector3();
const _axisZ = new THREE.Vector3(0, 0, 1);

/**
 * Le lot des POWER-UPS qui tombent — un seul draw call, une couleur par instance.
 *
 * Mêmes principes que `QuadBatch` (quads instanciés, allocation fixe, `begin`/
 * `add`/`end`), mais la couleur passe par `instanceColor` : chaque TYPE de bonus
 * a sa teinte, et le matériau reste unique (un programme, borné au warm-up).
 */
export class PickupView {
  readonly mesh: THREE.InstancedMesh;
  private n = 0;

  constructor(capacity: number, renderOrder: number) {
    // Un quad propre à ce lot : `instanceColor` vit sur le mesh, pas sur une
    // géométrie partagée qui se ferait écraser.
    const geo = new THREE.PlaneGeometry(1, 1);
    this.mesh = new THREE.InstancedMesh(geo, makePickupMaterial(), capacity);
    this.mesh.frustumCulled = false;
    this.mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage);
    // Blanc par défaut (multiplicateur neutre). Renseigner `instanceColor` active
    // `USE_INSTANCING_COLOR` → la varying `vColor` que le matériau exploite.
    this.mesh.instanceColor = new THREE.InstancedBufferAttribute(
      new Float32Array(capacity * 3).fill(1),
      3,
    );
    this.mesh.instanceColor.setUsage(THREE.DynamicDrawUsage);
    this.mesh.renderOrder = renderOrder;
    this.mesh.count = 0;
  }

  begin(): void {
    this.n = 0;
  }

  /** `angle` en radians : les jetons tournent doucement sur eux-mêmes pour attirer
   *  l'œil. `r`/`g`/`b` portent la teinte du TYPE de bonus. */
  add(x: number, y: number, size: number, angle: number, r: number, g: number, b: number): void {
    if (this.n >= this.mesh.instanceMatrix.count) return;
    _p.set(x, y, 0);
    _s.set(size, size, 1);
    _q.setFromAxisAngle(_axisZ, angle);
    _m.compose(_p, _q, _s);
    this.mesh.setMatrixAt(this.n, _m);
    this.mesh.instanceColor!.setXYZ(this.n, r, g, b);
    this.n++;
  }

  end(): void {
    this.mesh.count = this.n;
    this.mesh.instanceMatrix.needsUpdate = true;
    this.mesh.instanceColor!.needsUpdate = true;
  }
}
